import sriLankaObject from './sriLanka/sriLankaObject'
import greeceObject from './greece/greeceObject'
import chinaObject from './china/chinaObject'
import brazilObject from './brazil/brazilObject'

const narrativesObject = [
    greeceObject,
    sriLankaObject,
    brazilObject,
    chinaObject,
]

export default narrativesObject